var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('b-spinner',{attrs:{"type":"grow","label":"Loading..."}}),_c('div',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }